<template>
    <div class="c c-quickscan">
        <div class="c-quickscan__title">{{t["Quickscan.Title"]}}</div>
        <div class="c-quickscan__form">
            <div class="c-form__floatinglabels">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <h4>{{t["Quickscan.PersonalData.Title"]}}</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-voornaam">{{t["Quickscan.PersonalData.FirstName.Title"]}} <span>*</span></label>
                            <input type="text" name="Voornaam" id="quickscan-voornaam" class="form-control" v-model="voornaam" :class="{ 'input-validation-error': $v.voornaam.$error, 'success': !$v.voornaam.$error }" ref="voornaam">
                            <span class="field-validation-error" v-if="$v.voornaam.$error">{{t["Quickscan.PersonalData.FirstName.Error"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-achternaam">{{t["Quickscan.PersonalData.LastName.Title"]}} <span>*</span></label>
                            <input type="text" name="Achternaam" id="quickscan-achternaam" class="form-control" v-model="achternaam" :class="{ 'input-validation-error': $v.achternaam.$error, 'success': !$v.achternaam.$error }" ref="achternaam">
                            <span class="field-validation-error" v-if="$v.achternaam.$error">{{t["Quickscan.PersonalData.LastName.Error"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-bedrijfsnaam">{{t["Quickscan.PersonalData.Company.Title"]}} <span>*</span></label>
                            <input type="text" name="Bedrijfsnaam" id="quickscan-bedrijfsnaam" class="form-control" v-model="bedrijfsnaam" :class="{ 'input-validation-error': $v.bedrijfsnaam.$error, 'success': !$v.bedrijfsnaam.$error }" ref="bedrijfsnaam">
                            <span class="field-validation-error" v-if="$v.bedrijfsnaam.$error">{{t["Quickscan.PersonalData.Company.Error"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-emailadres">{{t["Quickscan.PersonalData.EmailAddress.Title"]}} <span>*</span></label>
                            <input type="text" name="E-mailadres" id="quickscan-emailadres" class="form-control" v-model="emailadres" :class="{ 'input-validation-error': $v.emailadres.$error, 'success': !$v.emailadres.$error }" ref="emailadres">
                            <span class="field-validation-error" v-if="$v.emailadres.$error">{{t["Quickscan.PersonalData.EmailAddress.Error"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="c c-hr">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <h4>{{t["Quickscan.Dimensions.Title"]}}</h4>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="settings.culture === 'nl-NL'">
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-lengte">{{t["Quickscan.Dimensions.Length.Title"]}} <span>*</span></label>
                            <input type="text" id="quickscan-lengte" class="form-control" v-model="lengteNL" :class="{ 'input-validation-error': $v.lengteNL.$error, 'success': !$v.lengteNL.$error }" ref="lengte">
                            <span class="field-validation-error" v-if="$v.lengteNL.$error && !$v.lengteNL.required">{{t["Quickscan.Dimensions.Length.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.lengteNL.$error && !$v.lengteNL.alphaNumAndCommaValidator">{{t["Quickscan.Dimensions.Length.Error.Format"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-breedte">
                                {{t["Quickscan.Dimensions.Width.Title"]}} <span>*</span>
                            </label>
                            <input type="text" id="quickscan-breedte" class="form-control" v-model="breedteNL" :class="{ 'input-validation-error': $v.breedteNL.$error, 'success': !$v.breedteNL.$error }" ref="hoogte">
                            <span class="field-validation-error" v-if="$v.breedteNL.$error && !$v.breedteNL.required">{{t["Quickscan.Dimensions.Width.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.breedteNL.$error && !$v.breedteNL.alphaNumAndCommaValidator">{{t["Quickscan.Dimensions.Width.Error.Format"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-hoogte">{{t["Quickscan.Dimensions.Height.Title"]}} <span>*</span></label>
                            <input type="text" id="quickscan-hoogte" class="form-control" v-model="hoogteNL" :class="{ 'input-validation-error': $v.hoogteNL.$error, 'success': !$v.hoogteNL.$error }" ref="breedte">
                            <span class="field-validation-error" v-if="$v.hoogteNL.$error && !$v.hoogteNL.required">{{t["Quickscan.Dimensions.Height.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.hoogteNL.$error && !$v.hoogteNL.alphaNumAndCommaValidator">{{t["Quickscan.Dimensions.Height.Error.Format"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-lengte">{{t["Quickscan.Dimensions.Length.Title"]}} <span>*</span></label>
                            <input type="text" id="quickscan-lengte" class="form-control" v-model="lengte" :class="{ 'input-validation-error': $v.lengte.$error, 'success': !$v.lengte.$error }" ref="lengte">
                            <span class="field-validation-error" v-if="$v.lengte.$error && !$v.lengte.required">{{t["Quickscan.Dimensions.Length.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.lengte.$error && !$v.lengte.alphaNumAndDotValidator">{{t["Quickscan.Dimensions.Length.Error.Format"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-breedte">{{t["Quickscan.Dimensions.Width.Title"]}} <span>*</span></label>
                            <input type="text" id="quickscan-breedte" class="form-control" v-model="breedte" :class="{ 'input-validation-error': $v.breedte.$error, 'success': !$v.breedte.$error }" ref="hoogte">
                            <span class="field-validation-error" v-if="$v.breedte.$error && !$v.breedte.required">{{t["Quickscan.Dimensions.Width.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.breedte.$error && !$v.breedte.alphaNumAndDotValidator">{{t["Quickscan.Dimensions.Width.Error.Format"]}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-hoogte">{{t["Quickscan.Dimensions.Height.Title"]}} <span>*</span></label>
                            <input type="text" id="quickscan-hoogte" class="form-control" v-model="hoogte" :class="{ 'input-validation-error': $v.hoogte.$error, 'success': !$v.hoogte.$error }" ref="breedte">
                            <span class="field-validation-error" v-if="$v.hoogte.$error && !$v.hoogte.required">{{t["Quickscan.Dimensions.Height.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.hoogte.$error && !$v.hoogte.alphaNumAndDotValidator">{{t["Quickscan.Dimensions.Height.Error.Format"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="c c-hr">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <h4>{{t["Quickscan.DesiredRoomTemperature.Title"]}}</h4>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="settings.culture === 'nl-NL'">
                    <div class="col-12 col-md-5 col-lg-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-temperatuur">{{t["Quickscan.DesiredRoomTemperature.Tempature.Title"]}} <span>*</span></label>
                            <input type="text" name="Temperatuur in &deg;C" id="quickscan-temperatuur" class="form-control" v-model="temperatuurNL" :class="{ 'input-validation-error': $v.temperatuurNL.$error, 'success': !$v.temperatuurNL.$error }" ref="temperatuur">
                            <span class="field-validation-error" v-if="$v.temperatuurNL.$error && !$v.temperatuurNL.required">{{t["Quickscan.DesiredRoomTemperature.Tempature.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.temperatuurNL.$error && !$v.temperatuurNL.alphaNumAndCommaValidator">{{t["Quickscan.DesiredRoomTemperature.Tempature.Error.Format"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 col-md-5 col-lg-4">
                        <div class="form-group umbraco-forms-field shortanswer">
                            <label for="quickscan-temperatuur">{{t["Quickscan.DesiredRoomTemperature.Tempature.Title"]}} <span>*</span></label>
                            <input type="text" name="Temperatuur in &deg;C" id="quickscan-temperatuur" class="form-control" v-model="temperatuur" :class="{ 'input-validation-error': $v.temperatuur.$error, 'success': !$v.temperatuur.$error }" ref="temperatuur">
                            <span class="field-validation-error" v-if="$v.temperatuur.$error && !$v.temperatuur.required">{{t["Quickscan.DesiredRoomTemperature.Tempature.Error"]}}</span>
                            <span class="field-validation-error" v-if="$v.temperatuur.$error && !$v.temperatuur.alphaNumAndCommaValidator">{{t["Quickscan.DesiredRoomTemperature.Tempature.Error.Format"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="c c-hr">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group umbraco-forms-field ikgaakkoordmethetprivacybeleidvanwinterwarm checkboxwithurl mandatory alternating">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" name="dataconsent" id="dataconsent" v-model="dataconsent" class="custom-control-input">
                                <label class="custom-control-label" for="dataconsent" v-html="t['Quickscan.DataConsent.Label']"></label>
                            </div>
                            <span class="field-validation-error" v-if="$v.dataconsent.$error">{{t["Quickscan.DataConsent.Error"]}}</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="errorMessage !== ''">
                    <div class="col-12">
                        <div class="c-message">
                            <div class="alert alert-danger">{{errorMessage}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="c-formsubmit">
                            <button type="button" class="btn btn-default" @click="sendForm()" :disabled="sending">
                                <i><span></span></i>
                                <span>{{t["Quickscan.Button"]}}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="successMessage !== ''">
                    <div class="col-12">
                        <div class="c-message">
                            <div class="alert alert-success">{{successMessage}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, requiredIf, email, minValue, helpers, sameAs } from 'vuelidate/lib/validators';
    import forms from '../../forms/forms.module.js';
    import axios from 'axios';

    var alphaNumAndDotValidator = helpers.regex('alphaNumAndDot', /^[0-9]{1,}([.][0-9]{1,2})?$/i);
    var alphaNumAndCommaValidator = helpers.regex('alphaNumAndComma', /^[0-9]{1,}([,][0-9]{1,2})?$/i);

    export default {
        data() {
            return {
                sending: false,
                t: {},
                voornaam: '',
                achternaam: '',
                bedrijfsnaam: '',
                emailadres: '',
                lengteNL: '',
                breedteNL: '',
                hoogteNL: '',
                lengte: '',
                breedte: '',
                hoogte: '',
                temperatuurNL: '',
                temperatuur: '',
                dataconsent: false,
                errorMessage: '',
                successMessage: ''
            };
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        },
        methods: {
            sendForm() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    if (this.$v.voornaam.$error) {
                        this.$refs.voornaam.focus();
                    } else if (this.$v.achternaam.$error) {
                        this.$refs.achternaam.focus();
                    } else if (this.$v.bedrijfsnaam.$error) {
                        this.$refs.bedrijfsnaam.focus();
                    } else if (this.$v.emailadres.$error) {
                        this.$refs.emailadres.focus();
                    } else if (this.$v.lengte.$error) {
                        this.$refs.lengte.focus();
                    } else if (this.$v.breedte.$error) {
                        this.$refs.breedte.focus();
                    } else if (this.$v.hoogte.$error) {
                        this.$refs.hoogte.focus();
                    } else if (this.$v.temperatuur.$error) {
                        this.$refs.temperatuur.focus();
                    }
                } else {
                    var t = this;
                    var query = '?firstname=' + this.voornaam + '&language=' + this.settings.culture + '&lastname=' + this.achternaam + '&companyname=' + this.bedrijfsnaam + '&emailadres=' + this.emailadres + '&length=' + this.lengte + '&width=' + this.breedte + '&height=' + this.hoogte + '&temperature=' + this.temperatuur;
                    if (t.settings.culture === 'nl-NL') {
                        query = '?firstname=' + this.voornaam + '&language=' + this.settings.culture + '&lastname=' + this.achternaam + '&companyname=' + this.bedrijfsnaam + '&emailadres=' + this.emailadres + '&length=' + this.lengteNL + '&width=' + this.breedteNL + '&height=' + this.hoogteNL + '&temperature=' + this.temperatuurNL;
                    }

                    t.sending = true;
                    axios.get('/umbraco/api/quickscan/SendCalculationMail' + query)
                        .then((response) => {
                            // Success
                            console.log(response);
                            window.location.replace(this.settings.thankyoupage);
                        })
                        .catch((e) => {
                            console.log(e.response.data);
                            var errorM = e.response.data;
                            if (errorM === 'Succes') {
                                window.location.replace(this.settings.thankyoupage);
                            }
                            else if (errorM === 'ToHigh') {
                                t.errorMessage = t.t['Quickscan.Error.ToHigh'];
                            }
                            else if (errorM === 'CannotSendMail') {
                                t.errorMessage = t.t['Quickscan.Error.CannotSendMail'];
                            }
                            else {
                                t.errorMessage = t.t['Quickscan.Error.General'];
                            }
                            t.sending = false;
                      });
                }
            }
        },
        mounted () {
        forms();
            axios.get('/umbraco/api/translations/getalltranslations?locale=' + this.settings.culture + '&dictionaryKey=Quickscan')
                .then(response => {
                    this.t = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        validations: {
            voornaam: {
                required
            },
            achternaam: {
                required
            },
            bedrijfsnaam: {
                required
            },
            emailadres: {
                required,
                email
            },
            lengteNL: {
                required: requiredIf(function () {
                    return this.settings.culture === 'nl-NL';
                }),
                alphaNumAndCommaValidator
            },
            breedteNL: {
                required: requiredIf(function () {
                    return this.settings.culture === 'nl-NL';
                }),
                alphaNumAndCommaValidator
            },
            hoogteNL: {
                required: requiredIf(function () {
                    return this.settings.culture === 'nl-NL';
                }),
                alphaNumAndCommaValidator
            },
            lengte: {
                required: requiredIf(function () {
                    return this.settings.culture !== 'nl-NL';
                }),
                alphaNumAndDotValidator
            },
            breedte: {
                required: requiredIf(function () {
                    return this.settings.culture !== 'nl-NL';
                }),
                alphaNumAndDotValidator
            },
            hoogte: {
                required: requiredIf(function () {
                    return this.settings.culture !== 'nl-NL';
                }),
                alphaNumAndDotValidator
            },
            temperatuurNL: {
                required: requiredIf(function () {
                    return this.settings.culture === 'nl-NL';
                }),
                alphaNumAndCommaValidator
            },
            temperatuur: {
                required: requiredIf(function () {
                    return this.settings.culture !== 'nl-NL';
                }),
                alphaNumAndDotValidator
            },
            dataconsent: {
                sameAs: sameAs(() => true)
            }
        }
    };
</script>
